import { render } from "./EnWarningIcon.vue?vue&type=template&id=1c0065ac"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/icons/EnWarningIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c0065ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c0065ac', __exports__)) {
    api.reload('1c0065ac', __exports__)
  }
  
  module.hot.accept("./EnWarningIcon.vue?vue&type=template&id=1c0065ac", () => {
    api.rerender('1c0065ac', render)
  })

}


export default __exports__